
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/email-engagement-data",
      function () {
        return require("private-next-pages/customer-studio/email-engagement-data.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/email-engagement-data"])
      });
    }
  